import React from 'react';
import Spinner from 'react-spinkit';

import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';

import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { getDeviceId } from '../util/device';
import { fireAnalytics } from './utils';

import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { generateDeviceId, storeHistory } from '../store/actions/appActions';
import { mobileDeviceId } from '../store/actions/appActions';
import { fetchDevice } from '../store/actions/deviceActions';
import { fetchUser, clearUser } from '../store/actions/userActions';
import {
  fetchFeaturedPlaylist,
  fetchUserPlaylists,
  fetchHomePlaylist,
  fetchMyPlaylist,
  fetchActivePlaylist,
  clearFeaturedPlaylist,
  clearUserPlaylists,
  clearActivePlaylist,
} from '../store/actions/playlistActions';
import { fetchSubscription, clearSubscription } from '../store/actions/subscriptionActions';


export class SplashScreen extends React.Component {

  async componentDidMount() {
    try {
      Cookies.remove('auth__token');
      const deviceId = getDeviceId();
      fireAnalytics('Launch', 'Starting App', deviceId);
      await this.props.storeHistory(this.props.history);
      if (!this.props.app.SSSPDeviceId) {
        this.props.generateDeviceId(deviceId);
      }

      const deviceResult = await this.props.fetchDevice(this.props.app.SSSPDeviceId);
      if (deviceResult.errors === "Error") {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      if (deviceResult.type === FETCH_DEVICE_SUCCESS) {

        const emailId = deviceResult.payload.email;
        const { userId } = deviceResult.payload;
        await this.props.mobileDeviceId(userId);
        // TODO: Move this into a redux action.
        // if (bdAuth.getToken()) {
        const response = await bdReq.post('/emailLogin', { emailId });
        if (response.success) {
          bdAuth._storeToken(response.body);
        }
        // }

        const fetchUser = await this.props.fetchUser();
        if (fetchUser.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchSubscription = await this.props.fetchSubscription();
        if (fetchSubscription.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
        if (fetchFeaturedPlaylist.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchHomePlaylist = await this.props.fetchHomePlaylist();
        if (fetchHomePlaylist.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        console.log("Full Props : ", this.props);
        console.log("Last Played ID : ", this.props.activePlaylist.data.id);
        let fetchActivePlaylist = await this.props.fetchActivePlaylist(this.props.activePlaylist.data.id !== undefined ? this.props.activePlaylist.data.id : 'Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
        if (fetchActivePlaylist.errors === "No Artworks") {
          fetchActivePlaylist = await this.props.fetchActivePlaylist('Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
        }
        if (fetchActivePlaylist.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const playlists = await this.props.fetchUserPlaylists();
        if (playlists.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }

        let targetPlaylistId;

        if (this.props.activePlaylist.data.id) {
          targetPlaylistId = this.props.activePlaylist.data.id;
        } else {
          targetPlaylistId = playlists.payload[0].id;
        }

        await this.props.fetchActivePlaylist(targetPlaylistId);
        setTimeout(() => {
          this.props.history.push(`/playlist/${targetPlaylistId}`);
        }, 10);
      }
      else {
        this.props.clearFeaturedPlaylist();
        this.props.clearUserPlaylists();
        this.props.clearActivePlaylist();
        this.props.clearUser();
        this.props.clearSubscription();
        Cookies.remove('auth__token');
        Cookies.remove('artwork_Interval');
        const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
        if (fetchFeaturedPlaylist.type === 'FETCH_FEATURED_PLAYLIST_FAILURE') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        if (fetchFeaturedPlaylist.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchHomePlaylist = await this.props.fetchHomePlaylist();
        if (fetchHomePlaylist.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchMyPlaylist = await this.props.fetchMyPlaylist();
        if (fetchMyPlaylist.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        setTimeout(() => {
          this.props.history.push('/featured');
        }, 10);
      }
    }
    catch (e) {
      console.log("e", e);
    }

  }

  render() {
    return (
      <div className="SplashPage">
        <div className="SplashWrapper">
          <img className="Logo" src="assets/img/blackdove-logo-2020.png" alt="" />
          <Spinner name="folding-cube" color="white" fadeIn="none" style={{ width: '40px', height: '40px' }} />
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  generateDeviceId: (deviceId) => dispatch(generateDeviceId(deviceId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  storeHistory: (history) => dispatch(storeHistory(history)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchUserPlaylists: () => dispatch(fetchUserPlaylists()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
});
export default connect((state) => {
  const { app, activePlaylist } = state
  return {
    app,
    activePlaylist,
  }
}, mapDispatchToProps)(SplashScreen)